import { SidePanelStatus } from "@nova/component-side-panel-tab-container"
import { StatusAndProgressData } from "../generics/GenericLayerListItemProgress"

function useStubbedHook() {
    return {
        status: undefined,
    }
}
export function useProgressDecisions({
    id,
    useHook,
}: {
    id: string | undefined
    useHook: ((id: string) => StatusAndProgressData) | undefined
}) {
    const useDecidedHook = useHook && id ? useHook : useStubbedHook
    const { status } = useDecidedHook(id!)

    const canActivateFeature =
        !!status &&
        [
            SidePanelStatus.empty,
            SidePanelStatus.loading,
            SidePanelStatus.queued,
            SidePanelStatus.ready,
            SidePanelStatus.singleFileUploading,
            SidePanelStatus.upload,
            SidePanelStatus.uploading,
        ].includes(status)
    const canShowInspectorPanel =
        !status ||
        status === SidePanelStatus.failed ||
        status === SidePanelStatus.loading ||
        status === SidePanelStatus.live
    return { canActivateFeature, canShowInspectorPanel }
}
